import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import LeftThreeRates from './left-three-rates';
import LeftFourOffers from './left-four-offers';
import Extras from './left-extras.jsx';

const LeftColumn = props => {
  return (
    <div style={{ width: '65%', padding: '24px', float: 'left' }}>
      <LeftThreeRates {...props} />
      <LeftFourOffers {...props} />
      <Extras {...props} />
  </div>
  );
};

LeftColumn.propTypes = {
  reducerName: PropTypes.string.isRequired,
  openAddEditContractDialog: PropTypes.func.isRequired,
  deleteFromProduct: PropTypes.func,
  supplierEditable: PropTypes.bool,
  contractState: PropTypes.string,
  productType: PropTypes.string,
};

const mapStateToProps = ({ contracting }, { reducerName }) => ({
  supplierEditable: contracting[reducerName].getIn(['leftNav', 'supplierEditable']),
  contractState: contracting[reducerName].getIn(['leftNav', 'contractState']),
  productType: contracting[reducerName].getIn(['rightSideContent', 'productType']),
});
export default connect(mapStateToProps)(LeftColumn);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/product/left-column/left-column.jsx